<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col>
          <base-material-card
            v-if="!loading"
            color="primary"
            icon="mdi-bank"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Cash Drops Site {{ id }} Safe ID {{ safes[0].crypto_idnum }}
              </div>
              <div class="display-2 font-weight-light">
                {{ sitedetails.address }}, {{ sitedetails.city }} {{ sitedetails.zipcode }}  {{ sitedetails.timezone }}
              </div>
              <div class="display-2 font-weight-light">
                Open: {{ sitedetails.time_open }}  Close: {{ sitedetails.time_close }}
              </div>
            </template>
            <v-row>
              <v-spacer />
              <v-btn
                color="warning"
                to="/CCSiteReports"
              >
                Return
              </v-btn>
            </v-row>
            <div id="chart">
              <apexchart
                v-if="!loading && showvalidated"
                type="bar"
                height="370"
                :options="chartOptions"
                :series="safesums"
              />
            </div>

            <v-divider class="mt-3" />

            <v-data-table
              :headers="headers"
              :items="tabledata"
              :search="search"
              sort-by="timestamp"
              sort-desc
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Cash Drops</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />
                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                  >
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="startdate"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="startdate"
                          label="Start Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="startdate"
                        @change="onChange($event)"
                      />
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                  >
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      :return-value.sync="enddate"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="enddate"
                          label="End Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="enddate"
                        scrollable
                        @change="onEndChange($event)"
                      />
                    </v-menu>
                  </v-col>

                  <v-spacer />
                  <download-csv
                    :name="csvfilename()"
                    :data="csvdata()"
                  >
                    <v-btn color="info">
                      <v-icon
                        color="white"
                        left
                      >
                        mdi-arrow-down
                      </v-icon>CSV
                    </v-btn>
                  </download-csv>
                </v-toolbar>
              </template>
              <template v-slot:[`item.timestamp`]="{ item }">
                {{ format_time(item.timestamp) }}
              </template>
              <template v-slot:[`item.sum`]="{ item }">
                {{ format_amt(item.sum) }}
              </template>
              <template v-slot:no-data>
                <div class="display-2 font-weight-light">
                  Sorry, no messages to display for Smart Safe ID {{ id }}
                </div>
                <br>
              </template>
            </v-data-table>

            <apexchart
              v-if="!loading && showmanual"
              type="bar"
              height="370"
              :options="chartManualOptions"
              :series="mansums"
            />

            <v-data-table
              :headers="manualheaders"
              :items="safe_manual"
              :search="searchman"
              dense
              sort-by="timestamp"
              sort-desc
              :items-per-page="5"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Manual Deposits</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-text-field
                    v-model="searchman"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />
                  <v-spacer />
                  <download-csv
                    :name="csvfilenamemanual()"
                    :data="safe_manual"
                  >
                    <v-btn color="info">
                      <v-icon
                        color="white"
                        left
                      >
                        mdi-arrow-down
                      </v-icon>CSV
                    </v-btn>
                  </download-csv>
                </v-toolbar>
              </template>
              <template v-slot:[`item.timestamp`]="{ item }">
                {{ format_time(item.timestamp) }}
              </template>
              <template v-slot:[`item.amount`]="{ item }">
                {{ format_amt(item.amount/100) }}
              </template>
              <template v-slot:no-data>
                <div class="display-2 font-weight-light">
                  Sorry, No data to display
                </div>
                <br>
              </template>
            </v-data-table>
          </base-material-card>

          <div class="py-3" />
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { utcToZonedTime, format } from 'date-fns-tz'
  var numeral = require('numeral')

  export default {
    name: 'Deposits',
    props: ['id'],

    data () {
      return {
        calculating: true,
        search: '',
        searchman: '',
        sitedetails: '',
        menu: false,
        menu1: false,
        startdate: '',
        enddate: '',
        filteredtabledata: '',
        options: {
          chart: {
            sparkline: {
              enabled: true
            }
          },
          colors: ['#00aedb'],
          stroke: {
            width: 2,
            curve: 'smooth'
          },
          fill: {
            gradient: {
              shade: 'light',
              type: 'diagonal1',
              shadeIntensity: 0.5,
              gradientToColors: ['#3BA22F'],
              inverseColors: false,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 90, 100],
              colorStops: []
            }
          },
          xaxis: {
            crosshairs: {
              width: 1
            }
          },
          yaxis: {
            min: 0
          },
          title: {
            text: '$135,965',
            offsetX: 0,
            style: {
              fontSize: '24px',
              cssClass: 'apexcharts-yaxis-title'
            }
          },
          subtitle: {
            text: 'Revenue',
            offsetX: 0,
            style: {
              fontSize: '14px',
              cssClass: 'apexcharts-yaxis-title'
            }
          }
        },
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          fill: {
            type: 'gradient',
            gradient: {
              gradientToColors: ['#3bd6c6'],
              shadeIntensity: 1,
              opacityFrom: 0.9,
              opacityTo: 0.9,
              stops: [0, 90, 100]
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },
          title: {
            text: 'Cash in',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return numeral(value).format('$0,0.00')
              }
            }
          },
          xaxis: {
            categories: [],
            labels: {
              formatter: function (value) {
                return moment(value).format('YYYY-MM-DD: HH:mm:ss')
              }
            }
          }
        },
        chartManualOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          fill: {
            type: 'gradient',
            gradient: {
              gradientToColors: ['#3bd6c6'],
              shadeIntensity: 1,
              opacityFrom: 0.9,
              opacityTo: 0.9,
              stops: [0, 90, 100]
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },
          title: {
            text: 'Cash in',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return numeral(value).format('$0,0.00')
              }
            }
          },
          xaxis: {
            categories: [],
            labels: {
              formatter: function (value) {
                return moment(value).format('YYYY-MM-DD: HH:mm:ss')
              }
            }
          }
        },
        series: [{
          name: 'Deposits ',
          data: []
        }],
        headers: [
          { text: 'Locale Site Time', value: 'localtime', align: 'left' },
          { text: 'User ID', value: 'useridnum', align: 'center' },
          { text: 'Name', value: 'username', align: 'center' },
          { text: 'Deposit ID', value: 'userdepositid', align: 'center' },
          { text: 'Ones', value: 'ones', align: 'center' },
          { text: 'Fives', value: 'fives', align: 'center' },
          { text: 'Tens', value: 'tens', align: 'center' },
          { text: 'Twenties', value: 'twenties', align: 'center' },
          { text: 'Fifties', value: 'fifties', align: 'center' },
          { text: 'Hundreds', value: 'hundreds', align: 'center' },
          { text: 'Sum', value: 'sum', align: 'center' }
        ],
        manualheaders: [
          { text: 'Locale Site Time', value: 'localtime', align: 'left' },
          { text: 'User ID', value: 'useridnum', align: 'center' },
          { text: 'Deposit ID', value: 'userdepositid', align: 'center' },
          { text: 'Sum', value: 'amount', align: 'center' }
        ],
        valid: true,
        graphsums: [],
        graphdays: [],
        manualsums: [],
        error: '',
        dialog: false,
        deftime: true,
        icons: true,
        centered: true,
        activeBtn: 1,
        tabledata: '',
        grow: true,
        cashinperunit: '',
        loading: false
      }
    },
    timers: {
      log: { time: 10000, autostart: true, repeat: true }
    },
    computed: {
      showmanual () {
        if (this.$store.getters.getManualDeposits.length > 0) {
          return true
        }
        return false
      },
      showvalidated () {
        if (this.$store.getters.userdeposits.length > 0) {
          return true
        }
        return false
      },
      safesums () {
        this.items = this.$store.getters.userdeposits
        for (let deposit in this.items) {
          let depnotes = this.items[deposit].notes
          let count_ones = 0
          let count_fives = 0
          let count_tens = 0
          let count_twenties = 0
          let count_fifties = 0
          let count_hundreds = 0
          let sum = 0
          this.$log.debug(' LOCAL FUNC ', this.sitedetails)
          let output
          if (this.sitedetails.timezone && this.sitedetails.timezone === 'EST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = this.items[deposit].timestamp
            let timeZone = 'America/New_York'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' est format is ', output)
          } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'GMT') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = this.items[deposit].timestamp
            let timeZone = 'Europe/London'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' GMT format is ', output)
          } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'MST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = this.items[deposit].timestamp
            let timeZone = 'America/Denver'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' GMT format is ', output)
          } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'CST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = this.items[deposit].timestamp
            let timeZone = 'America/Chicago'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' GMT format is ', output)
          } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'PST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = this.items[deposit].timestamp
            let timeZone = 'America/Los_Angeles'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' GMT format is ', output)
          }
          let depuserrecs = this.$store.getters.depositusers
          let username = '*'
          for (let rec of depuserrecs) {
            let code = parseInt(rec.accesscode)
            if (code === this.items[deposit].useridnum) {
              username = rec.username
            }
          }
          Object.assign(this.items[deposit], { username: username })

          //          let loctime = moment(this.items[deposit].timestamp).tz("America/New_York").format('YYYY-MM-DD HH:mm:ss')
          // Object.assign(this.items[deposit], {localtime: loctime })
          Object.assign(this.items[deposit], { localtime: output })
          Object.assign(this.items[deposit], { ones: numeral().format('0.00') })
          Object.assign(this.items[deposit], { fives: numeral().format('0.00') })
          Object.assign(this.items[deposit], { tens: numeral().format('0.00') })
          Object.assign(this.items[deposit], { twenties: numeral().format('0.00') })
          Object.assign(this.items[deposit], { fifties: numeral().format('0.00') })
          Object.assign(this.items[deposit], { hundreds: numeral().format('0.00') })

          for (let index in depnotes) {
            if (this.items[deposit].notes[index].denom === 1) {
              count_ones = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { ones: numeral(count_ones).format('0.00') })
            } else if (this.items[deposit].notes[index].denom === 5) {
              count_fives = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { fives: numeral(count_fives * 5).format('0.00') })
            } else if (this.items[deposit].notes[index].denom === 10) {
              count_tens = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { tens: numeral(count_tens * 10).format('0.00') })
            } else if (this.items[deposit].notes[index].denom === 20) {
              count_twenties = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { twenties: numeral(count_twenties * 20).format('0.00') })
            } else if (this.items[deposit].notes[index].denom === 50) {
              count_fifties = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { fifties: numeral(count_fifties * 50).format('0.00') })
            } else if (this.items[deposit].notes[index].denom === 100) {
              count_hundreds = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { hundreds: numeral(count_hundreds * 100).format('0.00') })
            }
          }
          sum = (count_ones * 1) + (count_fives * 5) + (count_tens * 10) + (count_twenties * 20) + (count_fifties * 50) + (count_hundreds * 100)
          Object.assign(this.items[deposit], { sum: sum })
          // Object.assign(this.items[deposit], {ones:count_ones})
        }
        // trim to last 50
        let rev = this.items.concat()
        // only show the last 50 on the graph here
        let MAX_GRAPH_ELEMENTS = 50
        let graphdeps = rev.slice(Math.max(rev.length - MAX_GRAPH_ELEMENTS, 0))
        graphdeps.reverse()
        let graphdates = rev.slice(Math.max(rev.length - MAX_GRAPH_ELEMENTS, 0))
        // lets cut this thing up to how we want it
        // get note count
        // get the days in the array
        this.graphdays = [...(graphdates.map(data => data.localtime))]
        this.chartOptions = {
          xaxis: {
            categories: this.graphdays
          }

        }
        // this.chartOptions.xaxis.categories = this.graphdays
        // get the sums in the array
        // get the days in the array
        this.graphsums = [...(graphdeps.map(data => data.sum))]
        this.graphsums.reverse()
        // return this.items
        this.$log.debug(this.items)
        let start = this.items[0].localtime
        let end = this.items[this.items.length - 1].localtime
        if (this.deftime) {
          this.tabledata = this.items
          this.startdate = moment(start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
          this.enddate = moment(end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
        }

        return [{ name: 'Deposit Amounts', data: [...this.graphsums] }]
      },
      mansums () {
        return [{ name: 'Manual Deposits', data: [...this.manualsums] }]
      },
      safe_manual () {
        let man_dep = this.$store.getters.getManualDeposits
        this.$log.debug('MAN IS ', this.$store.getters.getManualDeposits)
        for (let dep in man_dep) {
          this.$log.debug(' LOCAL FUNC ', this.sitedetails)
          let output
          if (this.sitedetails.timezone && this.sitedetails.timezone === 'EST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = man_dep[dep].timestamp
            let timeZone = 'America/New_York'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' est format is ', output)
          } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'GMT') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = man_dep[dep].timestamp
            let timeZone = 'Europe/London'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' GMT format is ', output)
          } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'PST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = man_dep[dep].timestamp
            let timeZone = 'America/Los_Angeles'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' PST format is ', output)
          } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'MST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = man_dep[dep].timestamp
            let timeZone = 'America/Denver'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' PST format is ', output)
          } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'CST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = man_dep[dep].timestamp
            let timeZone = 'America/Chicago'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' PST format is ', output)
          }
          Object.assign(man_dep[dep], { localtime: output })
        }
        this.$log.debug(man_dep)
        this.graphsumdays = [...(man_dep.map(data => data.localtime))]
        this.chartManualOptions.xaxis.categories = this.graphsumdays
        // get the sums in the array
        // get the days in the array
        this.manualsums = [...(man_dep.map(data => data.amount / 100))]

        // this.manualsums.reverse()

        return man_dep
      },
      safe_data () {
        this.items = this.$store.getters.userdeposits
        for (let deposit in this.items) {
          let depnotes = this.items[deposit].notes
          let count_ones = 0
          let count_fives = 0
          let count_tens = 0
          let count_twenties = 0
          let count_fifties = 0
          let count_hundreds = 0
          let sum = 0
          this.$log.debug(' LOCAL FUNC ', this.sitedetails)
          let output
          if (this.sitedetails.timezone && this.sitedetails.timezone === 'EST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = this.items[deposit].timestamp
            let timeZone = 'America/New_York'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' est format is ', output)
          } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'GMT') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = this.items[deposit].timestamp
            let timeZone = 'Europe/London'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' GMT format is ', output)
          } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'PST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = this.items[deposit].timestamp
            let timeZone = 'America/Los_Angeles'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' GMT format is ', output)
          }
          //          let loctime = moment(this.items[deposit].timestamp).tz("America/New_York").format('YYYY-MM-DD HH:mm:ss')
          // Object.assign(this.items[deposit], {localtime: loctime })
          Object.assign(this.items[deposit], { localtime: output })
          Object.assign(this.items[deposit], { ones: 0 })
          Object.assign(this.items[deposit], { fives: 0 })
          Object.assign(this.items[deposit], { tens: 0 })
          Object.assign(this.items[deposit], { twenties: 0 })
          Object.assign(this.items[deposit], { fifties: 0 })
          Object.assign(this.items[deposit], { hundreds: 0 })

          for (let index in depnotes) {
            if (this.items[deposit].notes[index].denom === 1) {
              count_ones = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { ones: count_ones })
            } else if (this.items[deposit].notes[index].denom === 5) {
              count_fives = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { fives: count_fives })
            } else if (this.items[deposit].notes[index].denom === 10) {
              count_tens = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { tens: count_tens })
            } else if (this.items[deposit].notes[index].denom === 20) {
              count_twenties = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { twenties: count_twenties })
            } else if (this.items[deposit].notes[index].denom === 50) {
              count_fifties = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { fifties: count_fifties })
            } else if (this.items[deposit].notes[index].denom === 100) {
              count_hundreds = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { hundreds: count_hundreds })
            }
          }
          sum = (count_ones * 1) + (count_fives * 5) + (count_tens * 10) + (count_twenties * 20) + (count_fifties * 50) + (count_hundreds * 100)
          Object.assign(this.items[deposit], { sum: sum })
          // Object.assign(this.items[deposit], {ones:count_ones})
        }
        // trim to last 50
        let rev = this.items.concat()
        // only show the last 50 on the graph here
        let MAX_GRAPH_ELEMENTS = 50
        let graphdeps = rev.slice(Math.max(rev.length - MAX_GRAPH_ELEMENTS, 0))
        graphdeps.reverse()
        let graphdates = rev.slice(Math.max(rev.length - MAX_GRAPH_ELEMENTS, 0))
        // lets cut this thing up to how we want it
        // get note count
        // get the days in the array
        this.graphdays = [...(graphdates.map(data => data.localtime))]
        this.chartOptions = {
          xaxis: {
            categories: this.graphdays
          }

        }
        // this.chartOptions.xaxis.categories = this.graphdays
        // get the sums in the array
        // get the days in the array
        this.graphsums = [...(graphdeps.map(data => data.sum))]
        this.graphsums.reverse()
        // return this.items
        this.$log.debug(this.items)
        // set our original start and end dates
        // get the first element
        // get the last element

        return this.items
      },
      safe_data_table () {
        this.tabledata = this.filteredtabledata
        return this.tabledata
      },

      currentsafes () {
        let oursafes = this.$store.getters.safesstatus
        return oursafes
      },
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      }
    },
    watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.loading = true
      this.graphsums = []
      this.graphdays = ''
      // this.$log.debug('ID PASSED ', this.$route.params.id)
      this.id = this.$route.params.id
      if (this.$route.params.id === 'Rainbow 1369 (DOTS)') {
        this.id = 'Rainbow 1369'
      }
      this.sitedetails = this.$store.getters.loadedSites.find(location => this.id === location.idnum)
      console.log('id passed is ', this.id)
      this.getsitemap(this.id)
      // this.$store.dispatch('loadsafetransactions', this.$route.params.id)
    },
    destroyed () {
      this.$store.dispatch('stoprealtimeuserdeposits', this.safes)
      // this.$store.dispatch('resetsafetransactions')
    },
    methods: {
      log () {
        // this.items = this.$store.getters.cashinvalues
        // this.$log.debug('cheating ', this.items)
      },
      onChange (value) {
        this.$refs.menu.save(value)
        this.deftime = false
        this.tabledata = this.items
        this.$log.debug('value passed to on change function ', value)
        let newdate = moment(value, 'YYYY-MM-DD')
        let filtered = []
        let st = moment(newdate).subtract(1, 'day')
        let et = moment(this.enddate, 'YYYY-MM-DD').add(1, 'day')
        this.tabledata.forEach(entry => {
          let entrydate = this.formatForZone(entry.timestamp)
          let entrymom = moment(entrydate, 'YYYY-MM-DD')
          if (entrymom.isAfter(st) && entrymom.isBefore(et)) {
            filtered.push(entry)
          }
        })
        this.filteredtabledata = filtered
        this.tabledata = filtered
      },
      onEndChange (value) {
        this.$refs.menu1.save(value)
        this.deftime = false
        this.tabledata = this.items
        this.$log.debug('value passed to on end change function ', value)
        let newdate = moment(value, 'YYYY-MM-DD')
        let filtered = []
        let st = moment(this.startdate).subtract(1, 'day')
        let et = moment(newdate, 'YYYY-MM-DD').add(1, 'day')
        this.tabledata.forEach(entry => {
          let entrydate = this.formatForZone(entry.timestamp)
          let entrymom = moment(entrydate, 'YYYY-MM-DD')
          if (entrymom.isAfter(st) && entrymom.isBefore(et)) {
            filtered.push(entry)
          }
        })
        this.filteredtabledata = filtered
        this.tabledata = filtered
      },
      formatForZone (timestamp) {
        let timezone = this.sitedetails.timezone
        let sitetimezone
        let output
        let pattern = 'yyyy-MM-dd'

        if (timezone === 'EST') {
          sitetimezone = 'America/New_York'
        } else if (timezone === 'CST') {
          sitetimezone = 'America/Chicago'
        } else if (timezone === 'PST') {
          sitetimezone = 'America/Los_Angeles'
        } else if (timezone === 'MST') {
          sitetimezone = 'America/Denver'
        } else if (timezone === 'GMT') {
          sitetimezone = 'Europe/London'
        }
        let zonedTime = utcToZonedTime(timestamp, sitetimezone)
        output = format(zonedTime, pattern, { sitetimezone })
        return output
      },
      csvdata () {
        let data = []
        for (let i = 0; i < this.items.length; i++) {
          let rec = { date: this.items[i].localtime, username: this.items[i].username, useridnum: this.items[i].useridnum, userdepositid: this.items[i].userdepositid, ones: this.items[i].ones, fives: this.items[i].fives, tens: this.items[i].tens, twenties: this.items[i].twenties, fifties: this.items[i].fifties, hundreds: this.items[i].hundreds, sum: this.items[i].sum }
          data.push(rec)
        }
        return data
      },
      csvfilename () {
        let today = moment().format('YYYY-MM-DD')
        let filename = today + '_dep' + '_' + this.id + '.csv'
        this.$log.debug('file name ', filename)
        return filename
      },
      csvfilenamemanual () {
        let today = moment().format('YYYY-MM-DD')
        let filename = today + '_manualdep' + '_' + this.id + '.csv'
        this.$log.debug('file name ', filename)
        return filename
      },
      gettopurl (nav) {
        let url = nav + this.id
        return url
      },
      getsitemap (machineid) {
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          // this.$log.debug(`${key}: ${value}`)
          if (value.idnum === machineid) {
            if (value.siteunitsprofile) {
              let shop = {
                idnum: key,
                safeids: value.siteunitsprofile
              }
              this.location = shop
              this.safes = shop.safeids
              this.$log.debug('shop is ', shop)
              this.$store.dispatch('inituserdepositlistener', this.safes)
              this.$store.dispatch('loadDepositusers', this.sitedetails.idnum)

              this.$store.dispatch('loadunituserdeposits', this.safes[0])
              this.$store.dispatch('loadunitmanualdeposits', this.safes[0])

              // now go get the data for these sites in the shop array
              //
            }
          }
        }
      },
      format_time (ts) {
        this.$log.debug('TS passed to table is ', ts)
        return moment(ts).format('YYYY-MM-DD HH:mm:ss')
      },
      format_amt (amt) {
        this.$log.debug('amt ', amt)
        return numeral(amt).format('$0,0.00')
      },
      logErrors (promise) {
        promise.catch(console.error)
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
